export default __webpack_public_path__ + "static/media/download-icon-blue.d4fc07dc.svg";